import React from "react";
import {DataGridProps} from "../../components/form/SelectorGrid/DataGrids/Types/DataGridProps";
import {LabelFields, productFields} from "./Fields";
import PropsProxy from "../../components/layout/PropsProxy";

export default class FieldsProvider<Props extends DataGridProps> extends React.Component<Props, any> {
    render() {
        let fields = this.props.fields;
        if (!fields) {
            let component = null;
            let componentConfig = null;
            if (this.props.componentListFieldConfig) {
                componentConfig = this.props.componentListFieldConfig;
                component = this.props.componentListFieldConfig.componentname;
            } else if (this.props.componentConfig) {
                componentConfig = this.props.componentConfig;
                component = this.props.componentConfig.componentname;
            }
            switch (component) {
                case "product":
                    fields = productFields({componentConfig});
                    break;
                case "Label":
                    fields = LabelFields({componentConfig});
                    break;
            }
        }
        return (
            <PropsProxy fields={fields} {...this.props}>
                {this.props.children}
            </PropsProxy>
        );
    }
}